import './titleBar.scss';
import styling from '../core/styling.js';
import { getRequired, create, createDiv } from '../core/domMan';
export const wrapperName = 'titleBarWrapper';
export const identifier = 'titleBar';
export default (owner) => {
    let result = {};
    let titleBar = document.getElementById(identifier);
    if (titleBar) {
        Object.assign(result, {
            titleBar: titleBar,
            title: getRequired('titleBar-title'),
            subTitle: getRequired('titleBar-subTitle'),
            footerTitle: getRequired('titleBar-footerTitle'),
            playPauseBtn: getRequired('playPauseBtn')
        });
    }
    else {
        owner = owner ?? getRequired(wrapperName);
        result.titleBar = titleBar = createDiv(owner, { id: identifier, className: 'titleBar' });
        result.title = create(titleBar, 'h2', { id: 'titleBar-title' });
        result.subTitle = create(titleBar, 'h3', { id: 'titleBar-subTitle' });
        const d = createDiv(titleBar);
        result.playPauseBtn = create(d, 'input', { id: 'playPauseBtn', type: 'button', value: 'Play/Pause', className: 'titleBar-btn shadow mx-2 my-1 px-4 py-1' });
        result.footerTitle = create(d, 'span', { id: 'titleBar-footerTitle', className: 'titleBar-label' });
        styling.hide(titleBar);
    }

    result.setSubTitle = subTitle => result.subTitle.innerHTML = subTitle;

    result.setHeading = (title, subTitle = undefined) => {
        if (title) {
            result.title.innerHTML = title;
        }
        if (subTitle) {
            result.setSubTitle(subTitle);
        }
    }

    result.playPause = (timer) => {
        if (timer) {
            if (timer.isPlaying()) {
                timer.hide();
                result.playPauseBtn.value = 'Play';
            } else {
                timer.enter()
                result.playPauseBtn.value = 'Pause';
            };
        }
    }

    result.pause = (timer) => {
        if (timer?.isPlaying()) {
            result.playPause();
        }
    }

    return result;
};